"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FAVORITES_FILTER_GROUP_KEY = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdReactRouter = require("cccisd-react-router");
var _classnames = _interopRequireDefault(require("classnames"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cccisdApollo = require("cccisd-apollo");
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdPaginator = _interopRequireDefault(require("cccisd-paginator"));
var _courseDataAndProgress = _interopRequireDefault(require("./Course/courseDataAndProgress.graphql"));
var _sharedRegistrationProgress = _interopRequireDefault(require("./Course/sharedRegistrationProgress.graphql"));
var _Course = require("./Course");
var _productData = _interopRequireDefault(require("./Product/productData.graphql"));
var _FilterSideBar = _interopRequireDefault(require("./FilterSideBar"));
var _ListView = _interopRequireDefault(require("./ResourceLists/ListView"));
var _GridView = _interopRequireDefault(require("./ResourceLists/GridView"));
var _ListViewCover = _interopRequireDefault(require("./ResourceLists/ListViewCover"));
var _GridViewCover = _interopRequireDefault(require("./ResourceLists/GridViewCover"));
var _FilterTabBar = _interopRequireDefault(require("./FilterTabBar"));
var _TopFilterBar = _interopRequireDefault(require("./TopFilterBar"));
var _useFavorite2 = _interopRequireDefault(require("./ResourceLists/FavoriteButton/useFavorite.js"));
var _grid = _interopRequireDefault(require("cccisd-icons/grid6"));
var _menu = _interopRequireDefault(require("cccisd-icons/menu7"));
var _info = _interopRequireDefault(require("cccisd-icons/info"));
var _search = _interopRequireDefault(require("cccisd-icons/search"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross4"));
var _style = _interopRequireDefault(require("./style.css"));
var _excluded = ["forwardedRef"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, "catch": function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var FAVORITES_FILTER_GROUP_KEY = exports.FAVORITES_FILTER_GROUP_KEY = 'cccisd_favorites_filter_group';
var screenMd = 768;
try {
  screenMd = Number(_style["default"].md.replace(/[^\d]/g, ''));
} catch (e) {
  // must not be defined as bootstrap variable, so 768 is reasonable guess
}
var initialState = {
  loading: true,
  search: '',
  filters: [],
  session: 'All',
  perPage: 10,
  currentPage: 1,
  renderMode: 'list',
  isMobile: false,
  data: null,
  dataByTab: null
};
var Boilerplate = window.cccisd.boilerplate;
var Fortress = window.cccisd.fortress;

/** Component for individual resource tab. Allows searching, and filtering. */
var ResourcePortal = /*#__PURE__*/function (_React$Component) {
  function ResourcePortal() {
    var _this;
    _classCallCheck(this, ResourcePortal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ResourcePortal, [].concat(args));
    // don't assign initialState by reference, must do full copy
    _defineProperty(_this, "state", _objectSpread({}, initialState));
    _defineProperty(_this, "componentDidMount", function () {
      if (_this.props.displayOptions.portal && _this.props.displayOptions.portal.defaultPerPageOption) {
        _this.updatePerPage(_this.props.displayOptions.portal.defaultPerPageOption);
      }
      _this.getData();
      !_this.props.preventLayoutChange && window.addEventListener('resize', _this.checkIfMobile);
      _this.setState({
        renderMode: _this.props.displayOptions.resources.renderMode
      });
    });
    _defineProperty(_this, "componentDidUpdate", function (prevProps) {
      if (prevProps.id !== _this.props.id) {
        _this.setState(_objectSpread(_objectSpread({}, initialState), {}, {
          perPage: _this.state.perPage,
          renderMode: _this.state.renderMode,
          isMobile: _this.state.isMobile
        }));
        _this.getData();
      } else if (prevProps.currentTab !== _this.props.currentTab) {
        _this.setState({
          currentPage: 1
        });
        _this.getData();
      }
    });
    _defineProperty(_this, "getData", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var response, data, deploymentIds, result, deploymentData, childDeploymentData, depSharedRegistrationMap, sharedRegistrationData, sharedRegistrationResp, productIds, _result, productData, params, allTagQueries;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _cccisdAxios["default"].get(Boilerplate.route('api.resources.resource.index'), {
              params: {
                scope: _this.props.id
              }
            });
          case 2:
            response = _context.sent;
            data = response.data.data;
            /* Course Data */
            deploymentIds = data.filter(function (resource) {
              return resource.type === 'course';
            }).map(function (resource) {
              var metadata = JSON.parse(resource.published_metadata) || {};
              return metadata.deploymentId;
            });
            if (!(deploymentIds.length > 0)) {
              _context.next = 20;
              break;
            }
            _context.next = 8;
            return _cccisdApollo.client.query({
              query: _courseDataAndProgress["default"],
              variables: {
                deploymentIds: deploymentIds,
                pawnId: Fortress.auth() ? Fortress.user.acting.id : 0
              },
              fetchPolicy: 'network-only'
            });
          case 8:
            result = _context.sent;
            deploymentData = (0, _get2["default"])(result, 'data.flows.deploymentList', []) || [];
            childDeploymentData = (0, _get2["default"])(result, 'data.flows.childDeployments', []) || [];
            depSharedRegistrationMap = {};
            deploymentData.forEach(function (d) {
              var sharedRegistrationId = (0, _get2["default"])(d, 'assignment.settings.navigationSettings.registration.toggle', false) === true && (0, _get2["default"])(d, 'assignment.settings.navigationSettings.registration.isExternalRegistration', false) === true && (0, _get2["default"])(d, 'assignment.settings.navigationSettings.registration.externalRegistrationDeploymentId', false);
              sharedRegistrationId = parseInt(sharedRegistrationId, 10);
              if (Number.isInteger(sharedRegistrationId)) {
                depSharedRegistrationMap[d.deploymentId] = sharedRegistrationId;
              }
            });
            sharedRegistrationData = {};
            if (!(Object.keys(depSharedRegistrationMap).length > 0)) {
              _context.next = 19;
              break;
            }
            _context.next = 17;
            return _cccisdApollo.client.query({
              query: _sharedRegistrationProgress["default"],
              variables: {
                deploymentIds: Object.values(depSharedRegistrationMap),
                pawnId: Fortress.auth() ? Fortress.user.acting.id : 0
              },
              fetchPolicy: 'network-only'
            });
          case 17:
            sharedRegistrationResp = _context.sent;
            sharedRegistrationData = ((0, _get2["default"])(sharedRegistrationResp, 'data.flows.deploymentList', []) || []).reduce(function (allData, curr) {
              allData[curr.deploymentId] = curr.assignmentProgress;
              return allData;
            }, {});
          case 19:
            data = data.map(function (resource) {
              if (resource.type === 'course') {
                var _resource, _resource$courseData;
                var metadata = JSON.parse(resource.published_metadata) || {};
                resource.courseData = deploymentData.find(function (d) {
                  return Number.parseInt(d.deploymentId, 10) === Number.parseInt(metadata.deploymentId, 10);
                }) || {};
                resource.childDeploymentData = childDeploymentData.filter(function (d) {
                  return Number.parseInt(d.parentDeploymentId, 10) === Number.parseInt(metadata.deploymentId, 10);
                }) || {};
                var sharedRegistrationId = depSharedRegistrationMap[(_resource = resource) === null || _resource === void 0 ? void 0 : (_resource$courseData = _resource.courseData) === null || _resource$courseData === void 0 ? void 0 : _resource$courseData.deploymentId];
                resource.sharedRegistrationData = sharedRegistrationData[sharedRegistrationId];
                resource = _objectSpread(_objectSpread({}, resource), (0, _Course.setAssignmentProgress)(resource));
              }
              return resource;
            });
          case 20:
            /* Product Data */
            productIds = data.filter(function (resource) {
              return resource.type === 'product';
            }).map(function (resource) {
              return resource.product_id;
            });
            if (!(productIds.length > 0)) {
              _context.next = 27;
              break;
            }
            _context.next = 24;
            return _cccisdApollo.client.query({
              query: _productData["default"],
              variables: {
                productIds: productIds,
                pawnId: Fortress.auth() ? Fortress.user.acting.id : 0
              },
              fetchPolicy: 'network-only'
            });
          case 24:
            _result = _context.sent;
            productData = (0, _get2["default"])(_result, 'data.products.productList', []);
            data = data.map(function (resource) {
              if (resource.type === 'product') {
                resource.productData = productData.find(function (d) {
                  return Number.parseInt(d.productId, 10) === resource.product_id;
                }) || {};
                var licenseStatus = (0, _get2["default"])(resource, 'productData.licenseStatus', 'none') || 'none';
                resource.hasProductBeenOwned = licenseStatus === 'active' || licenseStatus === 'expired';
              }
              return resource;
            });
          case 27:
            params = new URLSearchParams(_this.props.location.search);
            allTagQueries = params.getAll('tag');
            _this.setState({
              filters: allTagQueries,
              loading: false,
              data: data,
              dataByTab: data.filter(function (d) {
                return Object.values(d.tag_handles).includes(_this.props.currentTab);
              })
            });
          case 30:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_this, "checkIfMobile", function () {
      var isMobile = window.innerWidth < screenMd;
      if (isMobile !== _this.state.isMobile) {
        _this.setState({
          isMobile: isMobile
        });
      }
      if (isMobile) {
        _this.setState({
          renderMode: 'list'
        });
      }
    });
    // This is used to check each resource's tags array, and compare it to
    // each filterGroup's tags array
    _defineProperty(_this, "_compareArrays", function (arr1, arr2) {
      return arr2.filter(function (e) {
        return arr1.includes(e);
      });
    });
    _defineProperty(_this, "_areHexCodesEqual", function (hex1, hex2) {
      if (hex1 && hex2 && hex1.length !== hex2.length) {
        hex1 = hex1.length === 4 ? hex1.replace(/#(.)(.)(.)/, '#$1$1$2$2$3$3') : hex1;
        hex2 = hex2.length === 4 ? hex2.replace(/#(.)(.)(.)/, '#$1$1$2$2$3$3') : hex2;
      }
      return hex1 === hex2;
    });
    _defineProperty(_this, "getFilteredData", function () {
      var _displayOptions$resou;
      var _this$state = _this.state,
        search = _this$state.search,
        data = _this$state.data,
        session = _this$state.session,
        filters = _this$state.filters;
      var _this$props = _this.props,
        currentTab = _this$props.currentTab,
        displayOptions = _this$props.displayOptions;

      // build object of activeFilters in realation to their groups
      function includes(obj, val) {
        obj = obj || {};
        return Object.keys(obj).some(function (k) {
          return obj[k] === val;
        });
      }
      var activeFilters = {};
      var activeGroups = _this.props.filterGroups.filter(function (group) {
        return group.tags.some(function (tag) {
          return filters.includes(tag);
        });
      });
      for (var i = 0; i < activeGroups.length; i++) {
        var group = activeGroups[i];
        var activeTags = group.tags.filter(function (tag) {
          return filters.includes(tag);
        });
        activeFilters[group.name] = activeTags;
      }

      // filter data based on active filters
      if (filters.length > 0) {
        data = data.filter(function (item) {
          return Object.keys(activeFilters).every(function (group) {
            return activeFilters[group].some(function (tag) {
              return includes(item.tag_handles, tag) || tag === FAVORITES_FILTER_GROUP_KEY && item.isFavorited;
            });
          });
        });
      }
      if (currentTab !== 'All') {
        data = data.filter(function (item) {
          return includes(item.tag_handles, currentTab);
        });
      }
      if (session !== 'All') {
        data = data.filter(function (item) {
          return includes(item.tag_handles == null ? [] : item.tag_handles, session);
        });
      }
      if (search !== '') {
        // apply search
        var lowerCaseSearch = search.toLowerCase();
        data = data.filter(function (item) {
          if (item.published_label !== null && item.published_label.toLowerCase().includes(lowerCaseSearch) || item.published_description !== null && item.published_description.toLowerCase().includes(lowerCaseSearch) || item.search_terms !== null && item.search_terms.some(function (term) {
            return term.toLowerCase().includes(lowerCaseSearch);
          })) {
            return true;
          }
          var metadata = JSON.parse(item.published_metadata) || {};
          var courseDescription = item.type === 'course' && (metadata.showMainIntroduction || metadata.showCourseSectionHeaders) && (0, _get2["default"])(item, 'courseData.assignment.settings.navigationSettings.courseDescription');
          if (!courseDescription) {
            return false;
          }
          var tmpMainIntro = (0, _get2["default"])(courseDescription, 'introduction.main', '');
          var tmpCourseHeaders = (0, _get2["default"])(courseDescription, 'introduction.courseSections', []).map(function (s) {
            return s.heading;
          });
          if (metadata.showMainIntroduction && tmpMainIntro.toLowerCase().includes(lowerCaseSearch)) {
            return true;
          }
          return metadata.showCourseSectionHeaders && tmpCourseHeaders.some(function (h) {
            return h.toLowerCase().includes(lowerCaseSearch);
          });
        });
      }
      var idsToSortToTop = {};
      if (Array.isArray(displayOptions === null || displayOptions === void 0 ? void 0 : (_displayOptions$resou = displayOptions.resources) === null || _displayOptions$resou === void 0 ? void 0 : _displayOptions$resou.featuredResourceList)) {
        idsToSortToTop = displayOptions.resources.featuredResourceList.reduce(function (all, currId) {
          all[currId] = true;
          return all;
        }, {});
      }

      // Set icons for each resource
      data = data.map(function (item) {
        var resourceTagsKeys = Object.keys(item.tag_handles || {});
        var resourceTagsArr = resourceTagsKeys.map(function (tagKey) {
          return item.tag_handles[tagKey];
        });
        item.icons = [];
        _this.props.filterGroups.forEach(function (filterGroup) {
          if (_this._compareArrays(filterGroup.tags, resourceTagsArr).length > 0) {
            if (filterGroup.icon) {
              item.icons.push({
                name: filterGroup.icon,
                color: filterGroup.color
              });
            }
          }
        });
        item.isFeatured = item.id in idsToSortToTop;
        return item;
      });
      return data.sort(function (a, b) {
        if (a.isFeatured && !b.isFeatured) {
          return -1;
        }
        if (b.isFeatured && !a.isFeatured) {
          return 1;
        }
        if (a.handle.toLowerCase() < b.handle.toLowerCase()) {
          return -1;
        }
        if (a.handle.toLowerCase() > b.handle.toLowerCase()) {
          return 1;
        }
        return 0;
      });
    });
    _defineProperty(_this, "getDataForPage", function (data) {
      return data.slice((_this.state.currentPage - 1) * _this.state.perPage, (_this.state.currentPage - 1) * _this.state.perPage + _this.state.perPage);
    });
    _defineProperty(_this, "searchHandler", function (event) {
      _this.setState({
        search: event.target.value,
        currentPage: 1
      });
    });
    _defineProperty(_this, "updateSession", function (session) {
      _this.setState({
        session: session,
        currentPage: 1
      });
    });
    _defineProperty(_this, "updatePerPage", function (value) {
      _this.setState({
        perPage: value,
        currentPage: 1
      });
    });
    _defineProperty(_this, "onPageChange", function (page) {
      _this.setState({
        currentPage: page
      });
    });
    _defineProperty(_this, "clearSearch", function () {
      _this.setState({
        search: ''
      });
    });
    _defineProperty(_this, "setResourceFavorited", function (resourceId, val) {
      _this.setState(function (prev) {
        return {
          data: prev.data.map(function (resource) {
            if (resource.id === resourceId) {
              resource.isFavorited = val;
            }
            return resource;
          })
        };
      });
    });
    _defineProperty(_this, "clearFilters", function () {
      _this.setState({
        filters: []
      });
      var params = new URLSearchParams(_this.props.location.search);
      _this.props.history.push("".concat(_this.props.location.pathname).concat(params.has('tab') ? "?tab=".concat(params.get('tab')) : ''));
    });
    _defineProperty(_this, "updateFilters", function (id) {
      var searchParams = new URLSearchParams(_this.props.location.search);

      // toggled filter OFF
      if (_this.state.filters.includes(id)) {
        _this.setState(function (prev) {
          return {
            filters: prev.filters.filter(function (item) {
              return item !== id;
            }),
            currentPage: 1
          };
        });
        var previousTags = searchParams.getAll('tag');
        searchParams["delete"]('tag');
        previousTags.forEach(function (tagId) {
          if (tagId !== id) {
            searchParams.append('tag', tagId);
          }
        });
      }
      // toggled filter ON
      else {
        _this.setState(function (prev) {
          return {
            filters: [].concat(_toConsumableArray(prev.filters), [id]),
            currentPage: 1
          };
        });
        searchParams.append('tag', id);
      }
      var searchString = '';
      var searchCount = 0;
      var _iterator = _createForOfIteratorHelper(searchParams.entries()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
            key = _step$value[0],
            val = _step$value[1];
          searchString += searchCount === 0 ? '?' : '&';
          searchString += "".concat(key, "=").concat(val);
          searchCount++;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      _this.props.history.push("".concat(_this.props.location.pathname).concat(searchString));
    });
    _defineProperty(_this, "renderDefaultResourceTiles", function (renderProps) {
      if (_this.state.renderMode === 'list') {
        return _this.props.displayOptions.resources.coverThumbnails ? /*#__PURE__*/_react["default"].createElement(_ListViewCover["default"], renderProps) : /*#__PURE__*/_react["default"].createElement(_ListView["default"], renderProps);
      }
      return _this.props.displayOptions.resources.coverThumbnails ? /*#__PURE__*/_react["default"].createElement(_GridViewCover["default"], renderProps) : /*#__PURE__*/_react["default"].createElement(_GridView["default"], renderProps);
    });
    _defineProperty(_this, "returnResult", function (dataForPage) {
      var renderResourceTiles = _this.props.renderResourceTiles;
      var commonViewProps = {
        displayOptions: _this.props.displayOptions.resources,
        getShareUrl: _this.getShareUrl,
        currentTab: _this.props.currentTab,
        data: dataForPage,
        collection: _this.props.collection,
        addToCollection: _this.props.addToCollection,
        removeFromCollection: _this.props.removeFromCollection,
        addToCollectionButtonLabel: _this.props.addToCollectionButtonLabel,
        useFavorite: function useFavorite(resource) {
          return (0, _useFavorite2["default"])({
            resource: resource,
            setResourceFavorited: _this.setResourceFavorited,
            rcHandle: _this.props.id
          });
        }
      };
      if (dataForPage.length === 0) {
        return /*#__PURE__*/_react["default"].createElement("h1", {
          className: _style["default"].noResult
        }, /*#__PURE__*/_react["default"].createElement(_info["default"], null), " No results found.");
      }
      if (renderResourceTiles) {
        return renderResourceTiles(commonViewProps, _this.renderDefaultResourceTiles);
      }
      return _this.renderDefaultResourceTiles(commonViewProps);
    });
    _defineProperty(_this, "getShareUrl", function (tab, resource) {
      // Share link defaults to resource center
      var base = _this.props.match.path.replace(/^([^:]*)(.*)/, '$1');
      var prefix = base.endsWith('/') ? '' : '/';
      var url = Boilerplate.url("".concat(base).concat(prefix).concat(tab, "/").concat(resource.id));

      // Some resources will use the "ViewShare" component from this package to handle sharing
      if (['course', 'document', 'link', 'video'].includes(resource.type)) {
        url = resource.share_url + "?rc=".concat(_this.props.location.pathname);
      }
      return url;
    });
    _defineProperty(_this, "hasCustomStyles", function (attribute) {
      var hasStyles = _this.props.displayOptions && _this.props.displayOptions.portal;
      return hasStyles && _this.props.displayOptions.portal[attribute];
    });
    return _this;
  }
  _inherits(ResourcePortal, _React$Component);
  return _createClass(ResourcePortal, [{
    key: "switchResourceRenderMode",
    value: function switchResourceRenderMode(mode) {
      this.setState({
        renderMode: mode
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
        _displayOptions$resou2;
      if (this.state.loading) {
        return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
          loading: true
        });
      }
      var displayOptions = this.props.displayOptions;
      var data = this.getFilteredData();
      var dataForPage = this.getDataForPage(data);
      var searchBarColorMatchesBackground = this._areHexCodesEqual((0, _get2["default"])(displayOptions, 'portal.backgroundColor'), (0, _get2["default"])(displayOptions, 'portal.searchBarColor'));
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('row', _style["default"].container),
        style: this.hasCustomStyles('backgroundColor') ? {
          backgroundColor: displayOptions.portal.backgroundColor
        } : {}
      }, this.props.filterGroups.length !== 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('col-md-3', _style["default"].sidebar)
      }, /*#__PURE__*/_react["default"].createElement(_FilterSideBar["default"], {
        filterGroups: this.props.filterGroups,
        filterTags: this.props.tags,
        filters: this.state.filters,
        filterUpdater: this.updateFilters,
        displayOptions: displayOptions
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(this.props.filterGroups.length !== 0 ? 'col-md-9' : 'col-md-12', _style["default"].noTopMargin, _style["default"].noPadding, _style["default"].results),
        style: {
          paddingLeft: this.props.filterGroups.length === 0 ? 0 : null
        }
      }, this.props.topFilterBar && /*#__PURE__*/_react["default"].createElement(_TopFilterBar["default"], {
        topFilterBar: this.props.topFilterBar,
        tags: this.props.tags,
        filterUpdater: this.updateSession
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(_style["default"].searchbarGroup),
        style: {
          backgroundColor: this.hasCustomStyles('searchBarColor') && displayOptions.portal.searchBarColor,
          display: displayOptions.resources.showPageControls === false || displayOptions.resources.hideDisplayLayoutToggle && displayOptions.resources.hideSearchBar ? 'none' : null,
          padding: searchBarColorMatchesBackground ? '0px' : ''
        }
      }, !this.state.isMobile && !displayOptions.resources.hideDisplayLayoutToggle && /*#__PURE__*/_react["default"].createElement("form", {
        className: (0, _classnames["default"])('btn-group'),
        style: {
          marginLeft: searchBarColorMatchesBackground ? '0px' : ''
        }
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        onClick: function onClick(e) {
          return _this2.switchResourceRenderMode('grid');
        },
        className: (0, _classnames["default"])('btn btn-secondary', this.state.renderMode === 'grid' ? 'active ' : '')
      }, /*#__PURE__*/_react["default"].createElement(_grid["default"], null)), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        onClick: function onClick(e) {
          return _this2.switchResourceRenderMode('list');
        },
        className: (0, _classnames["default"])('btn btn-secondary ', this.state.renderMode === 'list' ? 'active ' : '')
      }, /*#__PURE__*/_react["default"].createElement(_menu["default"], null))), !displayOptions.resources.hideSearchBar && /*#__PURE__*/_react["default"].createElement("form", {
        onSubmit: function onSubmit(e) {
          e.preventDefault();
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(_style["default"].wrapper, this.state.search && _style["default"].withData)
      }, /*#__PURE__*/_react["default"].createElement("input", {
        ref: function ref(input) {
          _this2.input = input;
        },
        type: "text",
        placeholder: "Search",
        value: this.state.search,
        onChange: this.searchHandler,
        className: "form-control"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].icon
      }, this.state.search ? /*#__PURE__*/_react["default"].createElement("span", {
        onClick: this.clearSearch
      }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)) : /*#__PURE__*/_react["default"].createElement(_search["default"], null))))), /*#__PURE__*/_react["default"].createElement(_FilterTabBar["default"], {
        filters: [].concat(_toConsumableArray(this.props.tags), _toConsumableArray(displayOptions !== null && displayOptions !== void 0 && (_displayOptions$resou2 = displayOptions.resources) !== null && _displayOptions$resou2 !== void 0 && _displayOptions$resou2.showFavoriteIcon ? [{
          id: FAVORITES_FILTER_GROUP_KEY,
          label: 'Favorites',
          name: FAVORITES_FILTER_GROUP_KEY
        }] : [])).filter(function (item) {
          return _this2.state.filters.includes(item.name);
        }),
        removeFilter: this.updateFilters,
        removeAllFilters: this.clearFilters
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('row ', _style["default"].pageData),
        style: {
          display: displayOptions.resources.showPageControls === false || displayOptions.resources.hideShowingResources && displayOptions.resources.hidePerPageDropdown ? 'none' : null
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('col-md-8', _style["default"].noPadding)
      }, !displayOptions.resources.hideShowingResources && /*#__PURE__*/_react["default"].createElement("h3", {
        className: _style["default"].resourceCount,
        style: this.hasCustomStyles('resourceCountLabelColor') ? {
          color: displayOptions.portal.resourceCountLabelColor
        } : {}
      }, "Showing ", data.length, " of ", this.state.dataByTab.length, " resources.")), this.props.displayOptions.portal && (!this.props.displayOptions.portal.perPageOptions || this.props.displayOptions.portal.perPageOptions.length !== 0) && !displayOptions.resources.hidePerPageDropdown && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('col-md-4', _style["default"].perPageWrapper, _style["default"].noPadding)
      }, /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: "per-page",
        className: "form-label"
      }, "Per page:"), /*#__PURE__*/_react["default"].createElement("select", {
        className: "form-select",
        onChange: function onChange(e) {
          return _this2.updatePerPage(Number(e.target.value));
        },
        value: this.state.perPage,
        name: "per-page",
        style: {
          width: 'auto'
        }
      }, this.props.displayOptions.portal && this.props.displayOptions.portal.perPageOptions ? this.props.displayOptions.portal.perPageOptions.map(function (perPage) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: perPage
        }, perPage);
      }) : [5, 10, 25, 50].map(function (perPage) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: perPage
        }, perPage);
      })))), this.returnResult(dataForPage), /*#__PURE__*/_react["default"].createElement(_cccisdPaginator["default"], {
        className: "float-end",
        currentPage: this.state.currentPage,
        total: Math.ceil(data.length / this.state.perPage),
        onPageChange: this.onPageChange
      })));
    }
  }]);
}(_react["default"].Component);
_defineProperty(ResourcePortal, "propTypes", {
  id: _propTypes["default"].string,
  currentTab: _propTypes["default"].string,
  topFilterBar: _propTypes["default"].object,
  filterGroups: _propTypes["default"].array,
  data: _propTypes["default"].array,
  tags: _propTypes["default"].array,
  displayOptions: _propTypes["default"].object,
  match: _propTypes["default"].object,
  renderResourceTiles: _propTypes["default"].func,
  showTabs: _propTypes["default"].bool,
  preventLayoutChange: _propTypes["default"].bool
});
var withRouterForwardRef = function withRouterForwardRef(Component) {
  var WithRouter = (0, _cccisdReactRouter.withRouter)(function (_ref2) {
    var forwardedRef = _ref2.forwardedRef,
      props = _objectWithoutProperties(_ref2, _excluded);
    return /*#__PURE__*/_react["default"].createElement(Component, _extends({
      ref: forwardedRef
    }, props));
  });
  return /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
    return /*#__PURE__*/_react["default"].createElement(WithRouter, _extends({}, props, {
      forwardedRef: ref
    }));
  });
};
var _default = exports["default"] = withRouterForwardRef(ResourcePortal);